import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
  standalone: true,
})
export class SafeUrlPipe implements PipeTransform {
  readonly #sanitizer = inject(DomSanitizer);

  transform(url: string): SafeResourceUrl {
    const sanitizedUrl = this.#sanitizer.sanitize(SecurityContext.URL, url) || '';
    return this.#sanitizer.bypassSecurityTrustResourceUrl(sanitizedUrl);
  }
}
